<template>
  <div class="row">
    <div class="col-md-12">
      <div class="form-horizontal">
        <div
          :class="{ 'has-error': validations.name_km }"
          class="form-group"
        >
          <label
            class="col-sm-3 control-label required"
            for="name_km"
          >{{ $t("field.label.position_name_km") }}</label>
          <div class="col-sm-9">
            <input
              id="name_km"
              v-model="position.name_km"
              :placeholder="$t('field.pla.position_name_km')"
              class="form-control"
              type="text"
            >
            <template v-if="validations.name_km">
              <FiledIsRequired :msg="validations['name_km'][0]" />
            </template>
          </div>
        </div>

        <div
          :class="{ 'has-error': validations.name_en }"
          class="form-group"
        >
          <label
            class="col-sm-3 control-label required"
            for="name_en"
          >{{ $t("field.label.position_name_en") }}</label>
          <div class="col-sm-9">
            <input
              id="name_en"
              v-model="position.name_en"
              :placeholder="$t('field.pla.position_name_en')"
              class="form-control"
              type="text"
            >
            <template v-if="validations.name_en">
              <FiledIsRequired :msg="validations['name_en'][0]" />
            </template>
          </div>
        </div>

        <div
          :class="{ 'has-error': validations.value }"
          class="form-group"
        >
          <label
            class="col-sm-3 control-label required"
            for="value"
          >{{ $t("field.label.position_value") }}</label>
          <div class="col-sm-9">
            <input
              id="value"
              v-model="position.value"
              :placeholder="$t('field.pla.position_value')"
              class="form-control"
              type="text"
            >
            <template v-if="validations.value">
              <FiledIsRequired :msg="validations['value'][0]" />
            </template>
          </div>
        </div>

        <div class="form-group">
          <div class="col-sm-offset-3 col-sm-9">
            <template v-if="$route.params.uuid">
              <button
                class="btn btn-info btn-sm margin-r-5"
                @click="update"
              >
                <i class="fa fa-check-circle" /> {{ $t("button.update") }}
              </button>
            </template>
            <template v-else>
              <button
                class="btn btn-primary btn-sm margin-r-5"
                @click="store"
              >
                <i class="fa fa-check-circle" /> {{ $t("button.save") }}
              </button>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FiledIsRequired from '@/components/FiledIsRequired'

export default {
  name: 'Form',
  components: { FiledIsRequired },
  data () {
    return {
      position: {
        name_en: null,
        name_km: null,
        value: null
      },
      validations: {}
    }
  },
  mounted () {
    this.getPosition()
  },
  methods: {
    store () {
      this.validations = {}
      this.$isLoading(true)
      this.$axios.post(process.env.VUE_APP_API + '/api/backend/positions', this.position)
        .then(() => {
          this.showToastr()
          this.$router.push({
            name: 'list-position'
          })
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.validations = error.response.data.errors
          } else {
            this.onResponseError(error)
          }
        })
        .finally(() => {
          this.$isLoading(false)
        })
    },
    update () {
      this.validations = {}
      this.$isLoading(true)
      this.position.position_uuid = this.$route.params.uuid
      this.$axios.put(process.env.VUE_APP_API + '/api/backend/positions', this.position)
        .then(() => {
          this.showToastr()
          this.$router.push({
            name: 'list-position'
          })
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.validations = error.response.data.errors
          } else {
            this.onResponseError(error)
          }
        })
        .finally(() => {
          this.$isLoading(false)
        })
    },
    getPosition () {
      if (!this.$route.params.uuid) {
        return 0
      }
      this.$isLoading(true)
      this.$axios.get(process.env.VUE_APP_API + '/api/backend/positions/' + this.$route.params.uuid)
        .then(({ data }) => {
          if (data.data) {
            this.position = data.data
          }
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.validations = error.response.data.errors
          } else {
            this.onResponseError(error)
          }
        })
        .finally(() => {
          this.$isLoading(false)
        })
    }
  }
}
</script>

<style scoped></style>
